module.exports = __webpack_public_path__ + "Framew-5239aa7f.webp";